import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Base_URL } from "../url";

const DocumentInfoScreen = () => {
  const { docno } = useParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDetails();
  }, [docno]);

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${Base_URL}/DocumentPostings/GetAcitDetailsFromAchd/${docno}`
      );
      setData(res.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch document info");
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h4 className="mb-3">Document Info</h4>

          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}

          {error && <Alert variant="danger">{error}</Alert>}

          {!loading && !error && data.length > 0 && (
            <>
              {data.map((doc, index) => (
                <Card key={doc.id} className="mb-4 p-3 border">
                  <h5 className="mb-3">
                    Document {index + 1}
                  </h5>

                  <Form>
                    <Row className="mb-2">
                      <Col md={3}>
                        <Form.Label>Doc No</Form.Label>
                        <Form.Control value={doc.docno} readOnly />
                      </Col>

                      <Col md={2}>
                        <Form.Label>FY</Form.Label>
                        <Form.Control value={doc.docfy} readOnly />
                      </Col>

                      <Col md={2}>
                        <Form.Label>Month</Form.Label>
                        <Form.Control value={doc.docfmDesc} readOnly />
                      </Col>

                      <Col md={5}>
                        <Form.Label>Company</Form.Label>
                        <Form.Control value={doc.docccDesc} readOnly />
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col md={3}>
                        <Form.Label>Posting Key</Form.Label>
                        <Form.Control value={doc.postingkeyDesc} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>GL</Form.Label>
                        <Form.Control value={doc.glDesc} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>Transaction</Form.Label>
                        <Form.Control value={doc.transactionCodeDesc} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>Account Type</Form.Label>
                        <Form.Control value={doc.accountTypeDesc} readOnly />
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col md={3}>
                        <Form.Label>Debit/Credit</Form.Label>
                        <Form.Control value={doc.debitcreditDesc} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>Amount</Form.Label>
                        <Form.Control value={doc.amount} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>Currency</Form.Label>
                        <Form.Control value={doc.currencyDesc} readOnly />
                      </Col>

                      <Col md={3}>
                        <Form.Label>Posting Date</Form.Label>
                        <Form.Control
                          value={
                            doc.postingDate
                              ? new Date(doc.postingDate).toLocaleDateString()
                              : ""
                          }
                          readOnly
                        />
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col md={4}>
                        <Form.Label>Organisation</Form.Label>
                        <Form.Control value={doc.organisationName} readOnly />
                      </Col>

                      <Col md={4}>
                        <Form.Label>Document Amount</Form.Label>
                        <Form.Control value={doc.documentAmount} readOnly />
                      </Col>

                      <Col md={4}>
                        <Form.Label>Group Amount</Form.Label>
                        <Form.Control value={doc.groupAmount} readOnly />
                      </Col>
                    </Row>
                  </Form>
                </Card>
              ))}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentInfoScreen;